/**
 * Format bytes to human-readable string
 * @param {number} bytes - Number of bytes
 * @returns {string} Formatted string (e.g., "1.5 MB")
 */
export const formatBytes = (bytes) => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
}

/**
 * Validate file before upload
 * @param {File} file - File to validate
 * @returns {Object} { valid: boolean, error?: string }
 */
export const validateUploadFile = (file) => {
  const MAX_SIZE = 500 * 1024 * 1024 // 500MB
  const ALLOWED_EXTENSIONS = ['.sav', '.csv', '.xlsx', '.xls']
  
  if (!file) {
    return { valid: false, error: 'No file selected' }
  }
  
  // Check file size
  if (file.size > MAX_SIZE) {
    return { 
      valid: false, 
      error: `File too large. Maximum size is ${formatBytes(MAX_SIZE)}` 
    }
  }
  
  // Check file extension
  const fileName = file.name.toLowerCase()
  const hasValidExtension = ALLOWED_EXTENSIONS.some(ext => fileName.endsWith(ext))
  
  if (!hasValidExtension) {
    return { 
      valid: false, 
      error: 'Unsupported file format. Please upload .sav, .csv, .xlsx, or .xls files.' 
    }
  }
  
  return { valid: true }
}